import { formatUSPhone } from "src/utils";

import { Contact, getContactTitle } from "../../internal-contacts";
import { JobChatSummary } from "../../job-chats";
import { SmsContact } from "../../virtual-receptionist/sms/contacts/types/SmsContact";

export const resolveJobChatName = (chat: Pick<JobChatSummary, "alias" | "jobId">): string => {
  return chat.alias || `Job #${chat.jobId}`;
};

export const resolveGroupChatName = (group: { name?: string | null }): string => {
  return group?.name?.trim() || "Group chat";
};

export const resolveInternalChatName = (contact: Contact): string => {
  return getContactTitle(contact) || "Internal chat";
};

export const resolveSmsChatName = (phoneNumber: string, contact?: SmsContact["contact"] | null): string => {
  if (contact) {
    const firstName = contact.firstName || contact.name || "";
    const lastName = contact.lastName || "";
    const fullName = [firstName, lastName].filter(Boolean).join(" ").trim();

    if (fullName) return fullName;
  }

  return formatUSPhone(phoneNumber) || phoneNumber;
};

export const buildChatDockLabel = (companyName: string, chatName: string): string => {
  if (companyName && chatName) return `${companyName} - ${chatName}`;

  return chatName || companyName || "Chat";
};
